import { createAsyncThunk } from '@reduxjs/toolkit';

import { toast } from 'react-toastify';

import i18n from 'src/i18n/i18n';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from 'src/constants';
import { profileApi } from 'src/api/profile';

const normalizeLanguage = (value) => {
  if (!value) return null;

  return SUPPORTED_LANGUAGES.includes(value) ? value : null;
};

const applyLanguage = async (value) => {
  const normalized = normalizeLanguage(value);

  if (!normalized) {
    return null;
  }

  localStorage.setItem('language', normalized);

  if (i18n.resolvedLanguage !== normalized || i18n.language !== normalized) {
    await i18n.changeLanguage(normalized);
  }

  return normalized;
};

export const fetchUserProfile = createAsyncThunk(
  'profile/fetch-user-profile',
  async (_, thunkApi) => {
    try {
      const response = await profileApi.fetchUserProfile();

      const profileLanguage = normalizeLanguage(response?.data?.data?.language) || DEFAULT_LANGUAGE;
      const storedLanguage = normalizeLanguage(localStorage.getItem('language'));

      if (!storedLanguage) {
        await applyLanguage(profileLanguage);
      } else if (i18n.resolvedLanguage !== storedLanguage || i18n.language !== storedLanguage) {
        await i18n.changeLanguage(storedLanguage);
      }

      return response.data;
    } catch (error) {
      console.error('fetchUserProfile[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'profile/update-user-profile',
  async (data, thunkApi) => {
    try {
      const { payload } = data;

      const response = await profileApi.updateUserProfile(payload);
      const updatedLanguage =
        normalizeLanguage(response?.data?.data?.language) || payload?.language;

      if (updatedLanguage) {
        await applyLanguage(updatedLanguage);
      }

      await thunkApi.dispatch(fetchUserProfile());

      toast(response.data.message, { type: 'success' });

      return response.data;
    } catch (error) {
      console.error('updateUserProfile[error]', error);

      const message = error?.response?.data?.message || 'Something went wrong';

      toast(message, { type: 'error' });

      return thunkApi.rejectWithValue(message);
    }
  }
);
